import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.visible = false;
  }
  get isAppMaker() {
    return window.lowcode.__IS_APP_MAKER__;
  }
  get appendToBody() {
    return !this.isAppMaker;
  }
  get bodyStyle() {
    if (!this.bodyPadding) return {};
    return {
      padding: this.bodyPadding
    };
  }
  get closeOnClickModal() {
    return this.closeTypes.includes('close-on-click-modal');
  }
  get closeOnPressEscape() {
    return this.closeTypes.includes('close-on-press-escape');
  }
  get isCustomFooter() {
    return this.footer === 'custom';
  }
  get footerEnabled() {
    return this.footer === true && !!(this.cancelText || this.confirmText);
  }
  get confirmLoading() {
    return this.confirmState === 'loading';
  }
  get confirmDisabled() {
    return this.confirmState === 'disabled';
  }
  handleVisibleChange() {
    if (!this.enableClose) {
      this.visible = true;
      return;
    }
    if (this.visible) document.addEventListener('keydown', this.handleKeydown);else document.removeEventListener('keydown', this.handleKeydown);
  }
  show() {
    this.visible = true;
  }
  close() {
    this.visible = false;
  }
  cancelModal() {
    if (!this.enableClose) return;
    if (this.$listeners.cancel) this.$emit('cancel', () => this.close());else this.close();
  }
  confirmModal() {
    if (!this.enableClose) return;
    if (this.$listeners.confirm) this.$emit('confirm', () => this.close());else this.close();
  }
  /**
   * 处理 esc 关闭弹窗事件
   * yxt-drawer 的 esc 关闭存在 bug
   */
  handleKeydown(e) {
    if (!this.closeOnPressEscape || !this.visible || e.key !== 'Escape') return;
    e.stopPropagation();
    this.close();
  }
  created() {
    this.visible = this.initVisible;
  }
};
__decorate([Prop({
  default: true
})], default_1.prototype, "initVisible", void 0);
__decorate([Prop({
  default: '50%'
})], default_1.prototype, "width", void 0);
__decorate([Prop({
  default: true
})], default_1.prototype, "cutline", void 0);
__decorate([Prop({
  default: true
})], default_1.prototype, "modal", void 0);
__decorate([Prop({
  default: '24px'
})], default_1.prototype, "bodyPadding", void 0);
__decorate([Prop({
  default: () => []
})], default_1.prototype, "closeTypes", void 0);
__decorate([Prop({
  default: true
})], default_1.prototype, "footer", void 0);
__decorate([Prop({
  default: 'right'
})], default_1.prototype, "footerAlign", void 0);
__decorate([Prop({
  default: () => {
    return window.lowcode.i18n.get('apaas_amui_dialog_cancel', '取消');
  }
})], default_1.prototype, "cancelText", void 0);
__decorate([Prop({
  default: () => {
    return window.lowcode.i18n.get('apaas_amui_dialog_confirm', '确定');
  }
})], default_1.prototype, "confirmText", void 0);
__decorate([Prop({
  default: 'normal'
})], default_1.prototype, "confirmState", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], default_1.prototype, "enableClose", void 0);
__decorate([Watch('visible', {
  immediate: true
})], default_1.prototype, "handleVisibleChange", null);
default_1 = __decorate([Component({
  name: 'ModalMixin'
})], default_1);
export default default_1;